import React, { memo } from 'react';

interface InputProps {
  id?: string;
  disabled?: boolean;
  className?: string;
  closeOnSelect?: boolean;
  value?: string;
  styles?: Record<string, string>;
  placeholder?: string;
  onChange?: any;
  onBlur?: any;
  autotrim?: boolean;
  autoComplete?: string;
  name?: string;
  type?: string;
}

/** @deprecated TODO remove in DEV-25601 move to new component /shared/ui/Input */
const Input = ({ value = '', onChange, onBlur, autotrim = true, ...rest }: InputProps) => {
  const handleOnBlur = React.useCallback(
    (evt) => {
      if (onBlur) {
        onBlur(evt);
      }

      if (typeof value === 'string' && autotrim) {
        const trimmedValue = evt.target.value.trim();
        if (trimmedValue !== evt.target.value) {
          onChange({
            ...evt,
            target: {
              ...evt.target,
              value: trimmedValue,
            },
          });
        }
      }

      if (typeof value === 'number' && autotrim) {
        evt.target.value = parseFloat(evt.target.value);
        onChange(evt);
      }
    },
    [onBlur, onChange, value, autotrim],
  );

  const handleOnChange = React.useCallback(
    (evt) => {
      onChange(evt);
    },
    [onChange],
  );

  return <input {...rest} value={value} onBlur={handleOnBlur} onChange={handleOnChange} />;
};

// eslint-disable-next-line import/no-default-export
export default memo(Input);
